module.exports = {"410522101":"水冶镇","410522102":"铜冶镇","410522103":"善应镇","410522105":"柏庄镇","410522106":"白璧镇","410522107":"曲沟镇","410522108":"吕村镇","410522109":"伦掌镇","410522111":"崔家桥镇","410522112":"辛村镇","410522113":"韩陵镇","410522114":"永和镇","410522115":"都里镇","410522203":"磊口乡","410522204":"许家沟乡","410522205":"马家乡","410522210":"安丰乡","410522211":"洪河屯乡","410522214":"瓦店乡","410522216":"北郭乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/410522.json
// module id = 1440
// module chunks = 0